// @ts-nocheck
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { sectionActions } from 'ducks/section/actions';
import NooderaDatePicker from 'components/NooderaDatePicker';
import SectionCardItem from 'components/SectionCardItem/index';
import SectionInformation from 'components/SectionInformation';
import NooderaButton from 'components/NooderaButton/index';
import LoaderInline from 'components/uielements/LoaderInline';
import NooderaSwiper from 'components/NooderaSwiper/index';
import { SwiperSlide } from 'swiper/react';
import { TABLET_SMALLER_WIDTH, CELLPHONE_LARGE_WIDTH } from 'commons/constants/size';
import { useWidth } from 'utils/customHooks/index';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { ReactComponent as ExclamationIcon } from 'assets/svg/exclamation.svg';
import type { JoinSectionProps } from './JoinSection.types';
import {
  Wrapper,
  Container,
  TitleContainer,
  StyledTitle,
  ChangeSectionTypeText,
  SectionTitle,
  Section,
  Text,
  TextBold,
  NoItems,
  DatepickerContainer,
} from './JoinSection.styles';

const JoinSection = ({
  dateSelected,
  onChangeSection,
  onChangeDate,
  onNextStep,
  onFinish,
  headerTitle,
  onChangeHeaderTitle,
  onClose,
}: JoinSectionProps): React.ReactElement<any> => {
  const dispatch = useDispatch();
  const [selectedSection, setSelectedSection] = React.useState({});
  const sections = useSelector((state) => state.section?.sections.data);
  const sectionsLoading = useSelector((state) => state.section?.sections.isLoading);
  const userId = useSelector((state) => state.user?.id);
  const joinSection = useSelector((state) => state.section?.joinSection);
  const [sectionsOrdered, setSectionsOrdered] = React.useState([]);
  const width = useWidth();
  React.useEffect(() => {
    if (headerTitle?.value?.toLowerCase().includes('create')) {
      onChangeHeaderTitle();
    }
  }, [headerTitle?.value]);
  React.useEffect(() => {
    if (joinSection) {
      const { isLoading, success, error } = joinSection;

      if (!isLoading && success && !error) {
        if (onFinish) {
          onFinish();
          dispatch(sectionActions.resetJoinSection());
        }

        if (onNextStep) {
          onNextStep();
        }
      }

      if (isLoading) {
        <LoaderInline />;
      }
    }
  }, [joinSection]);
  React.useEffect(() => {
    if (sectionsLoading) {
      <LoaderInline />;
    }
  }, [sectionsLoading]);
  React.useEffect(() => {
    if (sections) {
      const sortedMeetings = sections
        .slice()
        .sort((a, b) => new Date(b.startDate).getTime() - new Date(a.startDate).getTime())
        .reverse();
      setSectionsOrdered(sortedMeetings);
    }
  }, [sections]);

  const handleSubmit = (): void => {
    dispatch(
      sectionActions.joinSectionRequest({
        selectedSection,
        userId,
      }),
    );
  };

  const renderNoItems = (): React.ReactElement<any> =>
    sectionsLoading ? (
      <LoaderInline />
    ) : (
      <NoItems>
        <ExclamationIcon />
        <span>No teams available</span>
        <span>
          {`There isn’t any team available after the ${moment(dateSelected).format('l')}`}.
        </span>
        <div>
          <NooderaButton onClick={() => onChangeDate(moment())}>View early teams</NooderaButton>
          <NooderaButton onClick={() => onChangeSection('create')}>Create team</NooderaButton>
        </div>
      </NoItems>
    );

  const renderCarousel = (items: Array<Record<string, any>>): React.ReactElement<any> =>
    items?.length ? (
      <NooderaSwiper
        showArrows={width > TABLET_SMALLER_WIDTH && items?.length > 1}
        spaceBetween={16}
        slidesPerView={1}
      >
        {items.map((item) => (
          <SwiperSlide key={item?.id}>
            <Section>
              <SectionCardItem
                item={item}
                selected={selectedSection?.id}
                onChange={(value) => setSelectedSection(value)}
              />
            </Section>
          </SwiperSlide>
        ))}
      </NooderaSwiper>
    ) : (
      renderNoItems()
    );

  return (
    <Wrapper>
      <Container>
        <TitleContainer>
          <StyledTitle>Join Team</StyledTitle>
          <ChangeSectionTypeText onClick={() => onChangeSection('create')}>
            Create Team
          </ChangeSectionTypeText>
        </TitleContainer>
        <SectionInformation
          icon={<InfoOutlinedIcon />}
          title='What’s a Team?'
          description='Every course on Noodle is intended to be taken with likeminded learners. You’ll be able to chat, share notes, and learn material together. Select a Team below to join and get started!'
        />
        <DatepickerContainer>
          <SectionTitle>Teams starting by</SectionTitle>
          <NooderaDatePicker
            minDate={new Date()}
            disablePast
            value={dateSelected}
            variant={width > CELLPHONE_LARGE_WIDTH ? 'inline' : 'dialog'}
            onChange={(value) => onChangeDate(value)}
            onClose={onClose}
          />
        </DatepickerContainer>
        {renderCarousel(sectionsOrdered)}
        <Section>
          <Text>Not sure which team to choose? You can also create&nbsp;</Text>
          <TextBold onClick={() => onChangeSection('create')}>your own team.</TextBold>
        </Section>
        <NooderaButton.CTA
          id={onNextStep ? '' : 'finish-free-course-enrollment'}
          isDisabled={!selectedSection?.id}
          onClick={handleSubmit}
        >
          {onNextStep ? 'Next' : 'Finish'}
        </NooderaButton.CTA>
      </Container>
    </Wrapper>
  );
};

export default JoinSection;
